module.exports = __webpack_public_path__ + "static/img/icon_qw.fabf5b27.png";